import React from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { deselectAllElements } from '../../../../element/selection/selectionActions';
import Button from '../../../../components/buttons/Button';

import './MobileToolbarDoneButton.scss';
import { ToolbarListType } from '../../../../workspace/toolbar/toolbarTypes';

const MobileToolbarDoneButton = ({
    className,
    setDefaultToolbarType,
}: {
    className?: string;
    setDefaultToolbarType: (toolbarType: ToolbarListType) => void;
}) => {
    const dispatch = useDispatch();

    const handleClick = () => {
        setDefaultToolbarType(ToolbarListType.MOBILE_TABS);

        return dispatch(deselectAllElements());
    };

    return (
        <Button className={classNames('MobileToolbarDoneButton', className)} onClick={handleClick}>
            Done
        </Button>
    );
};

export default MobileToolbarDoneButton;
